import React from 'react';
import { Spinner } from '@/components/ui/spinner';
import { DeveloperAccess } from '@/config/app';
import { useIntegrationAccess } from '@/contexts/IntegrationAccessContext';
import NotFoundPage from '@/pages/NotFound';

/**
 * Renders `children` only for a client whose integration API access (from
 * the backend, IntegrationAccessContext) allows it — the same check that
 * hides the menu entry, so a typed URL can't reach a hidden page (404
 * instead). While the answer is loading it shows a spinner, never the 404.
 */
const ClientGate: React.FC<{
  allowed: (access: DeveloperAccess) => boolean;
  children: React.ReactNode;
}> = ({ allowed, children }) => {
  const { access, ready } = useIntegrationAccess();
  if (!ready) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner size="lg" tone="neutral" />
      </div>
    );
  }
  return allowed(access) ? <>{children}</> : <NotFoundPage />;
};

export default ClientGate;
